const DesktopLinks = [
  {
    url: "/find-companies",
    text: "Find Companies",
  },
  {
    url: "/find-projects",
    text: "Find Projects",
  },

  {
    url: "/about-us",
    text: "Why ConsSols",
  },
];

const MobileLinks = [
  {
    url: "/",
    text: "Home",
  },
  {
    url: "/find-companies",
    text: "Find Companies",
  },
  {
    url: "/find-projects",
    text: "Find Projects",
  },
  {
    url: "/faqs",
    text: "FAQs",
  },
  {
    url: "/privacy-policy",
    text: "Privacy Policy",
  },
  {
    url: "/about-us",
    text: "About Us",
  },

  {
    url: "/contact-us",
    text: "Contact Us",
  },
];

export { DesktopLinks, MobileLinks };
